import { ADMIN_BASE } from '../config/adminLayers';

/** Base path for in-app admin links. */
export function useAdminBasePath(): string {
  return ADMIN_BASE;
}
